module.exports = __webpack_public_path__ + "img/logo-facebook.0a8c05b5.svg";